import {
    CAP_ITEM_DELETED,
    CAP_ITEM_SAVED,
    CAP_ITEMS_LOADED,
    CAP_ITEMS_LOADING, CAP_ITEMS_NEED_TO_RELOAD, CAP_LOADED, CAP_LOADING,
} from "./actionTypes";
import axios from "axios";
import {getConfig} from "./authActions";
import {returnAllErrorsAsPopup, returnErrors} from "./errorActions";
import {getSuccess} from "./successActions";
import {getPartnerId} from "../utils/authUtils";

export const loadCapItems = (params) => (dispatch, getState) => {
    const partnerIdsStr = params?.partnerIds.join(",") || "";
    const serviceGroupIdsStr = params?.serviceGroupIds.join(",") || "";
    const operatorIds = params?.operatorIds.join(",") || "";

    dispatch({type: CAP_ITEMS_LOADING});
    axios
        .get(process.env.REACT_APP_API_URL + '/caps/items?partnerIds=' + partnerIdsStr + "&serviceGroupIds=" + serviceGroupIdsStr
            + "&operatorIds=" + operatorIds, getConfig(getState))
        .then(res =>
            dispatch({
                type: CAP_ITEMS_LOADED,
                payload: res.data
            })
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};

export const setNeedToReloadCapItems = () => (dispatch, getState) => {
    dispatch({type: CAP_ITEMS_NEED_TO_RELOAD, payload: true});
}

export const saveOrUpdateCapItem = (capItem, onSuccessCallback) => (dispatch, state) => {
    dispatch({type: CAP_ITEMS_LOADING});
    axios
        .post(process.env.REACT_APP_API_URL + '/caps/items', capItem, getConfig(state))
        .then(res => {
                dispatch({type: CAP_ITEM_SAVED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "Позиция сохранена"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};

export const deleteCapItem = (id, onSuccessCallback) => (dispatch, state) => {
    dispatch({type: CAP_ITEMS_LOADING});
    axios
        .delete(process.env.REACT_APP_API_URL + '/caps/items/' + id, getConfig(state))
        .then(res => {
                dispatch({type: CAP_ITEM_DELETED});
            }
        )
        .then(() => {
            dispatch(getSuccess({success: "Позиция удалена"}))
        })
        .then(() => {
            onSuccessCallback && onSuccessCallback()
        })
        .catch(err => {
            dispatch(returnAllErrorsAsPopup(err));
        });
};

export const loadPartnerCaps = () => (dispatch, getState) => {
    const partnerId = getPartnerId();
    if (!partnerId) {
        return;
    }
    dispatch({type: CAP_LOADING});
    axios
        .get(process.env.REACT_APP_API_URL + '/caps/partnerItems?partnerId=' + partnerId, getConfig(getState))
        .then(res =>
            dispatch({
                type: CAP_LOADED,
                payload: res.data
            })
        )
        .catch(err => {
            dispatch(returnErrors(err));
        });
};